import React from "react"
import "./style.scss"

const ConnectCard = ({ onClick = () => {} }) => {
  return (
    <div className="connect-card">
      <div className="connect-avatar-container">
        <figure>
          <img src="/static/images/connect-avatar-one.svg" />
        </figure>
        <figure>
          <img src="/static/images/connect-avatar-two.svg" />
        </figure>
      </div>
      <div className="connect-cta-section">
        <span style={{ padding: 10 }}>
          Would you like to speak with our survey takers?
        </span>
        <div className="connect-cta-container">
          <div className="connect-cta-edge"></div>
          <div className="connect-cta-button-container">
            <div>Let us recommend the right one for you</div>
            <button onClick={onClick}>GET STARTED</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConnectCard
